import { useEffect } from 'react';

/* Publishes the really visible height (keyboard excluded) as --jp-app-h and flags body.jp-kb-open. */
export default function useVisibleViewport() {
  useEffect(() => {
    const vv = window.visualViewport;
    const root = document.documentElement;
    let raf = 0;
    const apply = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const h = vv ? vv.height : window.innerHeight;
        const kb = !!vv && window.innerHeight - vv.height > 120;
        root.style.setProperty('--jp-app-h', `${Math.round(h)}px`);
        root.style.setProperty('--jp-vv-top', `${Math.round(vv ? vv.offsetTop : 0)}px`);
        document.body.classList.toggle('jp-kb-open', kb);
        const el = document.activeElement;
        if (kb && el && /^(INPUT|TEXTAREA)$/.test(el.tagName)) el.scrollIntoView({ block: 'nearest' });
      });
    };
    apply();
    vv?.addEventListener('resize', apply);
    vv?.addEventListener('scroll', apply);
    window.addEventListener('orientationchange', apply);
    window.addEventListener('resize', apply);
    return () => {
      cancelAnimationFrame(raf);
      vv?.removeEventListener('resize', apply);
      vv?.removeEventListener('scroll', apply);
      window.removeEventListener('orientationchange', apply);
      window.removeEventListener('resize', apply);
      document.body.classList.remove('jp-kb-open');
      root.style.removeProperty('--jp-app-h');
      root.style.removeProperty('--jp-vv-top');
    };
  }, []);
}
